import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Container } from "reactstrap";
import ModalFrame from "../../../toolkit/modalFrame";
import { handleRequestError } from "../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import { updatePhotoProm } from "../../actions/persons";
import WebcamCapture from "../../components/common/WebCamCapture";
import s from "./photoModal.scss";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  history: any;
  uploadAction: (action: string, image: Blob) => void;
  partner: any;
  action: string;
}

class PhotoModal extends React.Component<Props> {
  render() {
    return (
      <ModalFrame
        title={`Actualizar ${this.props.action} de ${this.props.partner.nombre}`}
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        size="lg"
      >
        <Container className="text-center">
          <WebcamCapture
            personId={this.props.partner.idPersona}
            saveImage={img => {
              infoNotification("Guardando foto...");
              updatePhotoProm(this.props.partner.idPersona, img)
                .then((data: any) => {
                  successNotification("Foto guardada correctamente.");
                  //const fData = JSON.parse(data.data);
                  this.props.toggle();
                })
                .catch(handleRequestError);
            }}
          />
        </Container>
      </ModalFrame>
    );
  }
}

export default withRouter(withStyles(s)(PhotoModal));
